import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HospitalMeeting } from 'src/app/leader-toolkit/models/hospital-dashboard.model';

@Component({
  selector: 'vc-hospital-meetings-card',
  templateUrl: './hospital-meetings-card.component.html',
  styleUrl: './hospital-meetings-card.component.scss',
  standalone: false,
})
export class HospitalMeetingsCardComponent {
  @Input() nextMeeting: HospitalMeeting | null = null;
  @Input() upcomingMeetings: HospitalMeeting[] = [];
  @Input() isLoading = false;
  @Input() readOnly = false;

  upcomingOpen = true;

  @Output() addMeeting = new EventEmitter<void>();
  @Output() joinMeeting = new EventEmitter<HospitalMeeting>();
  @Output() viewMeeting = new EventEmitter<HospitalMeeting>();

  join(m: HospitalMeeting): void {
    if (this.readOnly) {
      return;
    }
    this.joinMeeting.emit(m);
  }

  openDetail(m: HospitalMeeting): void {
    if (this.readOnly) {
      return;
    }
    this.viewMeeting.emit(m);
  }

  onAddMeeting(): void {
    if (this.readOnly) {
      return;
    }
    this.addMeeting.emit();
  }
}